<template>
  <Card v-if="isVisible" class="shop-dashboard-widget-shop">
    <template #header>
      <FontAwesomeIcon :icon="['fal', 'fill-drip']" />
      <div>
        <h2>{{ $t('presentation') }}</h2>
      </div>
    </template>
    <template #default>
      <InputComponent :label="$t('status')" data-field="status">
        <ChoiceComponent
          v-model="value.status"
          @input="submit"
          :values="[
            { value: 'draft', label: $t('unpublished') },
            { value: 'published', label: $t('published') },
          ]"
        />
      </InputComponent>
    </template>
  </Card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { ChoiceComponent } from 'vue-elder-choice'
import ModelFactory from '@/models/utils/factory'
const Model = ModelFactory({ id: null, status: null })

import { InputComponent } from 'vue-elder-input'
import Card from '@/components/Card'

export default {
  watch: {
    item: {
      handler(val) {
        this.value = Model(val)
      },
      immediate: true,
    },
  },
  data() {
    return {
      value: Model(),
    }
  },
  computed: {
    ...mapState('Shop', {
      item: state => state.item,
      promises: state => state.promises,
    }),
    isVisible() {
      if (this.$path('reference.__typename', this.item) === 'ResidentialTemplate') return true

      const status = this.$path('reference.status', this.item)
      return status && status !== 'sold'
    },
  },
  methods: {
    ...mapActions('Shop', {
      submit(dispatch) {
        return dispatch('mutate', this.value)
      },
    }),
  },
  components: {
    Card,
    InputComponent,
    ChoiceComponent,
  },
}
</script>

<style lang="scss">
.shop-dashboard-widget-shop {
  & > .card__header {
    min-height: initial;
    flex-direction: row;
    justify-content: flex-start;

    & > svg {
      margin-right: 1.5rem;
    }

    h2 {
      margin: 0;
    }
  }

  & > .card__content {
    & > * + * {
      margin-top: 1rem;
    }
  }

  [data-field='status'] .elder-input__field {
    border: none;
  }
}
</style>
